export const productPlans = [
  {
    planName: "Starter Plan",
    price: "$29",
    packageFeatures: [
      { name: "10 GB Dedicated Hosting Free" },
      { name: "Best for Developers" },
      { name: "Freelancers 1 Year Support" },
    ],
    packageType: "This package is suitable for teams 1-15 people.",
  },
  {
    planName: "Basic Plan",
    price: "$79",
    packageFeatures: [
      { name: "15 GB Dedicated Hosting Free" },
      { name: "Best for Developers" },
      { name: "5 Year Support" },
      { name: "Free Custom Domain" },
      { name: "Basic Statistics" },
    ],
    packageType: "This package is suitable for teams 1-50 people.",
  },
  {
    planName: "Premium Plan",
    price: "$129",
    packageFeatures: [
      { name: "20 GB Dedicated Hosting Free" },
      { name: "Best for Developers" },
      { name: "Unlimited Support" },
      { name: "Free Custom Domain" },
      { name: "Full Statistics" },
    ],
    packageType: "This package is suitable for teams 1-100 people.",
  },
];
